import React from 'react'
import { Line } from 'react-chartjs-2'
import 'chartjs-plugin-datalabels';

const LineGraph = (props) => {
    let { title,title1,title2, x, y,y1,y2, width, height, lineColor,lineColor1,lineColor2, pointBorderColor,pointBorderColor1 ,pointBorderColor2} = props

    const dataSets = {
        labels: x,
        datasets: [
            {
                label: title,
                fill: false,
                lineTension: 0.4,
                backgroundColor: lineColor || '#EF4444',
                borderColor: lineColor || '#EF4444',
                borderWidth: 2,
                borderCapStyle: 'round',
                borderDash: [],
                borderDashOffset: 0.0,
                borderJoinStyle: 'round',
                pointBorderColor: pointBorderColor || lineColor || '#EF4444',
                pointBackgroundColor: '#fff',
                pointBorderWidth: 2,
                pointHoverRadius: 6,
                pointHoverBackgroundColor: lineColor || '#EF4444',
                pointHoverBorderColor: '#fff',
                pointHoverBorderWidth: 2,
                pointRadius: 3,
                pointHitRadius: 10,
                data: y,
                datalabels: {
                    display: true,
                    color: '#475569',
                    anchor: 'end',
                    align: 'top',
                    font: {
                        weight: '500',
                        size: 11,
                        family: 'Inter, sans-serif'
                    }
                }
            },
            {
                label: title1,
                fill: false,
                lineTension: 0.4,
                backgroundColor: lineColor1 || '#10B981',
                borderColor: lineColor1 || '#10B981',
                borderWidth: 2,
                borderCapStyle: 'round',
                borderDash: [],
                borderDashOffset: 0.0,
                borderJoinStyle: 'round',
                pointBorderColor: pointBorderColor1 || lineColor1 || '#10B981',
                pointBackgroundColor: '#fff',
                pointBorderWidth: 2,
                pointHoverRadius: 6,
                pointHoverBackgroundColor: lineColor1 || '#10B981',
                pointHoverBorderColor: '#fff',
                pointHoverBorderWidth: 2,
                pointRadius: 3,
                pointHitRadius: 10,
                data: y1,
                datalabels: {
                    display: true,
                    color: '#475569',
                    anchor: 'end',
                    align: 'top',
                    font: {
                        weight: '500',
                        size: 11,
                        family: 'Inter, sans-serif'
                    }
                }
            },
            {
                label: title2,
                fill: false,
                lineTension: 0.4,
                backgroundColor: lineColor2 || '#8B5CF6',
                borderColor: lineColor2 || '#8B5CF6',
                borderWidth: 2,
                borderCapStyle: 'round',
                borderDash: [],
                borderDashOffset: 0.0,
                borderJoinStyle: 'round',
                pointBorderColor: pointBorderColor2 || lineColor2 || '#8B5CF6',
                pointBackgroundColor: '#fff',
                pointBorderWidth: 2,
                pointHoverRadius: 6,
                pointHoverBackgroundColor: lineColor2 || '#8B5CF6',
                pointHoverBorderColor: '#fff',
                pointHoverBorderWidth: 2,
                pointRadius: 3,
                pointHitRadius: 10,
                data: y2,
                datalabels: {
                    display: true,
                    color: '#475569',
                    anchor: 'end',
                    align: 'top',
                    font: {
                        weight: '500',
                        size: 11,
                        family: 'Inter, sans-serif'
                    }
                }
            },
        ],
    };

    var options = {
        scales: {
            yAxes: [{
                stacked: false,
                ticks: {
                    beginAtZero: true,
                    fontFamily: 'Inter, sans-serif',
                    fontSize: 11,
                    fontColor: '#94A3B8',
                    padding: 8
                },
                gridLines: {
                    color: '#F1F5F9',
                    zeroLineColor: '#E2E8F0',
                    drawBorder: false
                }
            }],
            xAxes: [{
                stacked: false,
                ticks: {
                    beginAtZero: true,
                    fontFamily: 'Inter, sans-serif',
                    fontSize: 11,
                    fontColor: '#94A3B8',
                    padding: 8
                },
                gridLines: {
                    display: false
                }
            }]
        },
        legend: {
            position: 'bottom',
            display: true,
            labels: {
                boxWidth: 12,
                fontColor: '#475569',
                fontFamily: 'Inter, sans-serif',
                fontSize: 12,
                padding: 20,
                usePointStyle: true,
                pointStyle: 'circle'
            }
        },
        tooltips: {
            backgroundColor: '#0F172A',
            titleFontFamily: 'Inter, sans-serif',
            titleFontSize: 12,
            bodyFontFamily: 'Inter, sans-serif',
            bodyFontSize: 12,
            cornerRadius: 8,
            xPadding: 12,
            yPadding: 10,
            caretSize: 6,
            displayColors: true,
            mode: 'index',
            intersect: false
        },
        responsive: true,
        hover: {
            mode: 'index',
            intersect: false
        }
    };

    return (
        <Line width={width}
            height={height}
            data={dataSets}
            options={options}
        />
    )

}
export default LineGraph
